namespace TabAurous.Inventory {
    export interface BranchInRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        RefTransId?: number;
        BranchId?: number;
        CompanyName?: string;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        Username?: string;
        ItemDetails?: BranchInItemsRow[];
        TaxDetails?: BranchInTaxRow[];
        DepartmentId?: number;
        RoundOff?: number;
        ProductItemImage?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        RefVoucherId?: number;
        Authorize?: boolean;
        AuthorizedBy?: number;
        AuthorizedDate?: string;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
    }

    export namespace BranchInRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.BranchIn';
        export const deletePermission = 'Inventory:BranchIn:Delete';
        export const insertPermission = 'Inventory:BranchIn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:BranchIn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            RefTransId = "RefTransId",
            BranchId = "BranchId",
            CompanyName = "CompanyName",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            Username = "Username",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            DepartmentId = "DepartmentId",
            RoundOff = "RoundOff",
            ProductItemImage = "ProductItemImage",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            RefVoucherId = "RefVoucherId",
            Authorize = "Authorize",
            AuthorizedBy = "AuthorizedBy",
            AuthorizedDate = "AuthorizedDate",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff"
        }
    }
}
